import { router } from "./Router.jsx";
import { RouterProvider } from "react-router-dom";

function App() {
  /* dispatch step + ticket */
  return <RouterProvider router={router} />;
}

export default App;
